import { productsFunction } from "./registry/products";
import { traineeFunction } from "./registry/trainee";

/**
 * Split per service on purpose. The reference implementation this was modelled
 * on grew into one file with hundreds of DTO imports and became unmaintainable
 * (TRE-1684).
 */
export const CloudFunctions = {
  products: productsFunction,
  trainee: traineeFunction,
};

export { productsFunction, productsRoutes } from "./registry/products";
export { traineeFunction, traineeRoutes } from "./registry/trainee";
